<template>
  <div class="box layout-padding">
    <div style="margin-bottom:12px">
      <lp-check-bool :checkedVal.sync="input.check" label="서비스 가능 지역만 보기"></lp-check-bool>
    </div>

    <div style="overflow-x: auto">
      <div style="min-width: 800px">
        <table class="table">
          <tbody>
          <tr>
            <th v-for="tt in tableTitle">{{ tt }}</th>
          </tr>
          </tbody>
        </table>

        <!-- 1차 -->
        <div v-for="(sido, idx) in sidos" :key="'sido'+idx"
             v-if="(input.check && sido.partner_count >0) || input.check === false">
          <table class="table">
            <tr @click="click1(sido)" :class="{'lp-sel-color':sido.selected}">
              <td>{{ sido.level}}</td>
              <td>{{ sido.name }}</td>
              <td class="lp-allcount-div">
                <div>{{ sido.under_count }}</div>
                <div v-if="!sido.selected"><i class="fa fa-angle-down" aria-hidden="true"></i></div>
                <div v-if="sido.selected"><i class="fa fa-angle-up" aria-hidden="true"></i></div>
              </td>
              <td>{{ sido.partner_count === 0 ? '': sido.partner_count }}</td>
              <td>{{ sido.product_count === 0 ? '': sido.product_count }}</td>
              <td>{{ sido.featured_list.join() }}</td>
            </tr>
          </table>

          <!-- 2차 -->
          <div v-if="sido.selected && ((input.check && sigungu.partner_count >0) || input.check === false)"
               :key="'sigungu'+sidx" v-for="(sigungu, sidx) in sido.child">
            <table class="table">
              <tr @click="click2(sigungu)" :class="{'lp-sel-color':sigungu.selected}">
                <td>{{ sigungu.level }}</td>
                <td>{{ sigungu.name }}</td>
                <td class="lp-allcount-div">
                  <div>{{ sigungu.under_count }}</div>
                  <div v-if="!sigungu.selected"><i class="fa fa-angle-down" aria-hidden="true"></i></div>
                  <div v-else><i class="fa fa-angle-up" aria-hidden="true"></i></div>
                </td>
                <td>{{ sigungu.partner_count === 0 ? '': sigungu.partner_count }}</td>
                <td>{{ sigungu.product_count === 0 ? '': sigungu.product_count }}</td>
                <td>{{ sigungu.featured_list.join() }}</td>
              </tr>
            </table>

            <!-- 3차 -->
            <table class="table">
              <tr v-for="(dong, didx) in sigungu.child" :key="'dong'+didx"
                  v-if="sigungu.selected && ((input.check && dong.partner_count >0) || input.check === false)">
                <td>{{ dong.level }}</td>
                <td>{{ dong.name }}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </table>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import LpSortDropDown from "../../module/common/LpSortDropDown";
  import LpCheckBool from "../../module/common/LpCheckBool";

  export default {

    components: {

      LpCheckBool,
      LpSortDropDown
    },
    data() {
      return {
        input: {
          search: '',
          check: false,
          level: '',
        },
        tableTitle: ['레벨', '지역명', '하위 지역 수', '서비스 파트너 수', '서비스 상품 수', '소속된 Featured지역'],
        selectOptions: [{label: '레벨', value: '레벨'}],
        sidos: [],
        dongs: [],
      }
    },
    created() {
      this.getData();
    },
    methods: {
      // 시도군구 데이터 가져옴( 동빼고)
      getData() {
        this.$axios.get(this.getUrl('address/default/sido/present')).then(res => {
          if (res.status === 200) {
            this.sidos = res.data;
          }
        })
      },
      // 광역시 클릭
      click1(item) {
        if (item.selected) {
          item.selected = false;
        }
        else {
          this.$axios.get(this.getUrl(`address/default/sido/${item.id}/sigungu/present`)).then(res => {
            if (res.status === 200) {
              item.child = res.data;
            }
          })
          item.selected = true;
        }
      },
      // 시군구 클릭 (동 데이터 가져옴)
      click2(item) {
        if (item.selected) {
          item.selected = false;
        }
        else {
          this.$axios.get(`public/address/basic/sido/${item.sido}/sigungu/${item.id}/dong`).then(res => {
            if (res.status === 200) {
              item.child = res.data;
              for (let i = 0; i < res.data.length; i++) {
                res.data[i].level = '3차';

              }
            }
          })
          item.selected = true;
        }
      }
    }
  }
</script>

<style lang="styl" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .table
    margin-bottom 0

  .table:first-child
    border-bottom 1px solid grey

  .lp-sel-color
    background #f2f7f8

  td
    text-align center

  th:nth-of-type(1)
  th:nth-of-type(3)
  th:nth-of-type(4)
  th:nth-of-type(5)
    width 10%

  th:nth-of-type(2)
  th:nth-of-type(6)
    width 30%

  td:nth-of-type(1)
  td:nth-of-type(3)
  td:nth-of-type(4)
  td:nth-of-type(5)
    width 10%

  td:nth-of-type(2)
  td:nth-of-type(6)
    width 30%

  .lp-search
  .lp-checkbox
  .lp-select
    margin-left 12px

  .lp-checkbox
    label
      line-height 36px

  .lp-flex
    display flex

  .lp-search-title
    color $primary
    line-height 2.2rem

  .lp-search input
    background #f2f7f8
    border-radius 16px
    padding 0 12px

  .input[type=search]
    background #f2f7f8 !important

  .lp-checkbox > div
    line-height 2.2rem

  .lp-right-search
    padding 4px 16px
    border-radius 3px
    border 1px solid $primary
    color $primary
    line-height 1.7rem
    position absolute
    right 20px

  i
    position absolute
    top 50%
    transform translateY(-50%)
    right 12px
    font-size 1rem

  .lp-allcount-div
    position relative

</style>
